import { useWaitForTransactionReceipt } from "wagmi";
import { createRateLimiter } from "@/utils/debounce";

// 为transaction receipt查询创建独立的速率限制器
const receiptRateLimiter = createRateLimiter(30, 60000); // 每分钟最多30个请求

export interface UseTransactionReceiptOptions {
  enabled?: boolean;
  retryDelay?: number;
  maxRetries?: number;
}

export function useTransactionReceipt(
  hash: `0x${string}` | undefined,
  options: UseTransactionReceiptOptions = {}
) {
  const {
    enabled = true,
    retryDelay = 8000, // 增加到8秒，进一步减少RPC请求频率
    maxRetries = 15, // 减少最大重试次数
  } = options;

  // 使用优化的 wagmi hook 配置
  return useWaitForTransactionReceipt({
    hash,
    query: {
      enabled: !!hash && enabled,
      refetchInterval: (data) => {
        // 如果交易已确认（成功或失败），停止轮询
        console.log(data, ">>>>>data");
        if (
          data?.state?.data?.status === "success" ||
          data?.state?.data?.status === "reverted" ||
          data?.state?.data
        ) {
          return false;
        }

        // 检查速率限制
        if (!receiptRateLimiter.canMakeRequest()) {
          const waitTime = receiptRateLimiter.waitTime();
          return Math.max(retryDelay, waitTime);
        }

        receiptRateLimiter.recordRequest();
        return retryDelay;
      },
      retry: (failureCount, error) => {
        console.log(error, ">>>>>error", failureCount);

        // 如果是执行错误，不要重试
        if (
          error?.message?.includes("CallExecutionError") ||
          error?.message?.includes("execution fatal") ||
          error?.message?.includes("ModuleError") ||
          error?.message?.includes("An internal error was received")
        ) {
          return false;
        }

        // 速率限制错误\网络或连接错误才重试
        if (
          error?.message?.toLowerCase().includes("rate limit") ||
          error?.message?.toLowerCase().includes("network") ||
          error?.message?.toLowerCase().includes("timeout") ||
          error?.message?.toLowerCase().includes("fetch")
        ) {
          return failureCount < maxRetries;
        }

        // 其他错误不重试
        return false;
      },
      retryDelay: (attemptIndex, error) => {
        // 如果是速率限制错误，使用指数退避
        if (error?.message?.toLowerCase().includes("rate limit")) {
          return Math.min(retryDelay * Math.pow(2, attemptIndex), 30000); // 最大30秒
        }

        return retryDelay;
      },
    },
  });
}
